import PubSub from "underpub-js";
import gsap from "gsap";
import {
	nodeName
} from "jquery";

var ListingUnitTypes = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingUnitTypes',
	};

	$.extend(true, this.options, options);

};

ListingUnitTypes.prototype.init = function () {

	var self = this;

	// Select all dropdowns inside the filters container
	self.$filters = self.options.$el.find(`[data-filter]`);
	self.$items = self.options.$el.find(`.${self.options.baseClass}__item`);

	self.$filters.on("change", () => self.updateFilters());

};

ListingUnitTypes.prototype.updateFilters = function () {
	const self = this;
	let $activeItems = self.$items;

	// Loop through all filters and narrow down matching items
	self.$filters.each((i, filter) => {
		const $filter = $(filter);
		const filterKey = $filter.data("filter"); // e.g., 'bedroom', 'category', 'floor', etc
		const selectedValue = $filter.val();

		if (selectedValue) {
			$activeItems = $activeItems.filter((i, el) => {
				return $(el).data(filterKey)?.toString() === selectedValue.toString();
			});
		}
	});

	self.$activeItems = $activeItems;

	gsap.timeline({
		defaults: {
			ease: "expo.out",
			duration: 1,
		}
	})
		.to(self.$items, {
			duration: .4,
			opacity: 0,
		})
		.set(self.$items.not(self.$activeItems), {
			display: "none",
		})
		.set(self.$activeItems, {
			display: "block",
		})
		.to(self.$activeItems, {
			opacity: 1
		})
};

export default ListingUnitTypes;